import axios from "axios";

export const generatePdf = payload =>
  axios.post(
    "/api/v1/data_consumption_export/export",
    { data: payload },
    { responseType: "arraybuffer" }
  );
